import {useNavigate} from '@github-ui/use-navigate'
import {GlobalCommands} from '@github-ui/ui-commands'
import {PencilIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useCallback} from 'react'

export function EditButton({
  editPath,
  editTooltip,
  className,
}: {
  editPath?: string
  editTooltip: string
  className?: string
}): React.ReactElement | null {
  const navigate = useNavigate()

  const handleEditFile = useCallback(() => {
    if (editPath) {
      navigate(editPath)
    }
  }, [editPath, navigate])

  if (!editPath) return null

  return (
    <>
      <GlobalCommands commands={{'code-view:edit-file': handleEditFile}} />
      <IconButton
        icon={PencilIcon}
        className={className}
        aria-label={editTooltip}
        onClick={handleEditFile}
        size="small"
        variant="invisible"
      />
    </>
  )
}
